import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import Button from '../Button/Button'
import { deviceMax } from '../../theme/breakpoints'
import { NAVBAR_HEIGHT } from '../../theme/constants'
import NavbarItem from '../NavItem/NavbarItem'
import IconButton from '../IconButton/IconButton'

export const StyledNavbarDesktopContainer = styled.div`
  flex: 1;
  display: flex;
  height: 100%;
  @media ${deviceMax.tablet} {
    display: none;
  }
`
export const StyledNavbarMobileContainer = styled.div`
  flex: 1;
  display: none;
  height: ${pxToRem(50)};
  @media ${deviceMax.tablet} {
    align-items: center;
    display: flex;
  }
`

export const StyledButtonDesktop = styled(Button)`
  display: flex;
  width: fit-content;
  margin-left: ${pxToRem(16)};
  @media ${deviceMax.laptop} {
    display: none;
  }
`
export const IconButtonLaptop = styled(IconButton)`
  display: none;
  @media ${deviceMax.laptop} {
    display: flex;
  }
`

export const NavbarItemDesktop = styled(NavbarItem)`
  display: flex;
  @media ${deviceMax.laptop} {
    display: none;
  }
`

export const StyledNavbarList = styled.ul`
  position: relative;
  z-index: 100;
  align-items: center;
  display: flex;
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.unique.white};
  width: 100%;
  height: ${pxToRem(NAVBAR_HEIGHT.desktop)};
  backdrop-filter: blur(${pxToRem(10)});
  background-color: rgba(0, 0, 0, 0.7);
  @media ${deviceMax.tablet} {
    background-color: ${({ theme }) => theme.colors.unique.black};
    height: ${pxToRem(NAVBAR_HEIGHT.mobile)};
  }
`

export const StyledNavbarGroup = styled.div`
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  display: flex;
  height: inherit;
  padding: 0 ${pxToRem(20)};

  @media ${deviceMax.tablet} {
    padding: 0;
    justify-content: flex-end;
  }
`

export const StyledSeparator = styled.div`
  position: static;
  overflow: hidden;
  border: inherit;
  width: ${pxToRem(2)};
  height: inherit;
  background-color: ${({ theme }) => theme.colors.unique.white};
  @media ${deviceMax.mobileL} {
    height: ${pxToRem(50)};
  }
`

export const StyledNavbarGroupRight = styled.div`
  align-items: center;
  display: flex;
  padding-left: ${pxToRem(20)};
  padding-right: ${pxToRem(20)};
  height: 100%;

  @media ${deviceMax.tablet} {
    padding: 0;
  }
`

export const StyledButton = styled(Button)`
  width: fit-content;
  margin-left: ${pxToRem(16)};
`
